<mat-dialog-content>
    <sk-skipped-restore-items
        [resourceKey]="resourceKey"
        [redirectSourceKey]="redirectSourceKey"
        [jobId]="jobId">
    </sk-skipped-restore-items>
</mat-dialog-content>
